import {
  getThinkBody,
  getThinkTopic,
  isThinkToolActive,
  isThinkToolCall,
  type ThinkContentItem,
} from "./ToolCallCard.tools";
import { CollapsibleActionRow } from "./ToolCallCardCollapsibleActionRow";

type ThoughtActionRowProps = {
  item: ThinkContentItem;
  /**
   * Seconds the turn spent before this row, when it is the reply's first: the
   * reply's head says the same "Thought · n seconds" above it, so the head is
   * left off and the row says it instead of the two reading as two thoughts.
   */
  thoughtSeconds?: number | null;
};

/** Inline thought line — expanded while active, collapsible when done. */
export function ThoughtActionRow({
  item,
  thoughtSeconds,
}: ThoughtActionRowProps) {
  if (!isThinkToolCall(item)) {
    return null;
  }

  const isActive = isThinkToolActive(item);
  const topic = getThinkTopic(item);
  const displayTopic = topic !== "Thinking" ? topic : null;
  const label = isActive ? "Thinking" : "Thought";
  const took =
    thoughtSeconds != null
      ? `${thoughtSeconds} ${thoughtSeconds === 1 ? "second" : "seconds"}`
      : null;
  const header = [label, took, displayTopic].filter(Boolean).join(" · ");

  return (
    <CollapsibleActionRow
      header={header}
      body={getThinkBody(item)}
      isActive={isActive}
      error={item.toolError}
    />
  );
}
